var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"track-code-execution-error-representation"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_setup.props.title))]),_c('div',{staticClass:"helper"},[_vm._v(" Мы уже занимаемся ее решением, но вы можете ускорить нашу работу, если сообщите нам об этом ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }